import styled from 'styled-components';
import { floatingComponentStyles } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';
import { getScrollBarStyles } from '../../../config/styles';
import {
  TOOLTIP_MAX_WIDTH,
  TOOLTIP_MIN_WIDTH,
} from '../SingleChartDataTooltip/SingleChartDataTooltipUI';

export const CustomTooltipContainer = styled.div`
  max-width: ${TOOLTIP_MAX_WIDTH};
  min-width: ${TOOLTIP_MIN_WIDTH};
  font-size: 12px;
  color: ${theme.colors.secondary800};
  ${floatingComponentStyles};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;

export const ValueWrapper = styled.div<{ $color?: string }>`
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  border-left: ${({ $color }) => ($color ? `4px solid ${$color}` : 'none')};
`;

export const LineValueWrapper = styled.div`
  word-break: break-word;
  flex-grow: 1;
`;

export const TooltipHeader = styled.div`
  display: flex;
  column-gap: 12px;
  padding: 6px 16px;
`;

export const TooltipHeaderMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  font-size: 12px;
`;

export const TooltipHeaderMainInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  font-size: 10px;
`;

export const TooltipHeaderSecondary = styled.div`
  flex: 0 0 auto;
  align-self: flex-start;
  display: flex;
  align-items: center;
  column-gap: 6px;
  color: ${theme.colors.secondary900};
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
  ${getScrollBarStyles(4)};
  color: ${theme.colors.secondary900};
`;
